import * as FluxUtils from 'flux/utils';

import utils = egr.wcf.utils;
import eaiws = egr.wcf.eaiws;
import { ActionConstants } from '../constants/ActionConstants';
import { SortHelper } from '../utils/SortHelper';
import { DispatcherBaseAction, AppDispatcher } from '../dispatcher/AppDispatcher';

export interface CatalogStoreState {
    catalogPath: Array<eaiws.catalog.CatalogItem>;
    beforePath: Array<eaiws.catalog.CatalogItem>;
    catalogItems: Array<eaiws.catalog.CatalogItem>;
    filter: string | null;
    search: string | null;
}

class CatalogStoreClass extends FluxUtils.ReduceStore<CatalogStoreState, unknown> {
    public getInitialState(): CatalogStoreState {
        return {
            catalogPath: [],
            beforePath: [],
            catalogItems: [],
            filter: null,
            search: null
        };
    }

    public reduce(state: CatalogStoreState, action: DispatcherBaseAction): CatalogStoreState {
        // Note: this function should be `pure` -> we have to return a copy
        // of the current state if some property was changed

        switch (action.actionType) {
            case ActionConstants.CATALOG_UPDATE:
                const catalogPath: Array<eaiws.catalog.CatalogItem> = action.value.catalogPath == null ? [] : action.value.catalogPath;
                const catalogItems: Array<eaiws.catalog.CatalogItem> = action.value.items == null ? [] : action.value.items;

                if (catalogPath.length) {
                    // Note: the lodash sort function uses a signature which differs from the vanilla js sort function
                    // catalogItems = _.sortBy(catalogItems, this._sortByType);
                } else {
                    catalogItems.sort(
                        SortHelper.getSortFunctionForChain([
                            {
                                map: this.mapCatalogLabel,
                                sort: SortHelper.sortCaseInsensitive
                            }
                        ])
                    );
                }

                return jQuery.extend({}, state, {
                    catalogItems: catalogItems,
                    catalogPath: catalogPath,
                    beforePath: catalogPath.slice(0, -1),
                    search: ''
                });
            case ActionConstants.FILTER_CATALOG:
                return jQuery.extend({}, state, {
                    filter: action.value
                });
            case ActionConstants.SEARCH_CATALOG:
                return jQuery.extend({}, state, {
                    catalogItems: action.value.items == null ? [] : action.value.items,
                    catalogPath: action.value.catalogPath == null ? [] : action.value.catalogPath,
                    search: action.value.search,
                    beforePath: state.catalogPath
                });
            case ActionConstants.RESET_PROJECT_RELATED_SETTINGS:
                return jQuery.extend({}, this.getInitialState());
            default:
                break;
        }
        return state;
    }

    protected mapCatalogLabel(item: eaiws.catalog.CatalogItem): string {
        if (!utils.string.isNullOrEmpty(item.label)) {
            return item.label.toLocaleLowerCase();
        }

        if (!utils.string.isNullOrEmpty(item.name)) {
            return item.name.toLocaleLowerCase();
        }

        return '';
    }
}

export let CatalogStore: CatalogStoreClass = new CatalogStoreClass(AppDispatcher);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/CatalogStore.ts